import {WellEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseWellMultiSelectProps = Omit<
  BaseEntityMultiSelectProps<WellEntity>,
  'nameMapper'
>;

export const BaseWellMultiSelect = (props: BaseWellMultiSelectProps) => {
  const nameMapper = useCallback((e: WellEntity) => {
    return e.name;
  }, []);

  return <BaseEntityMultiSelect nameMapper={nameMapper} {...props} />;
};
